export const ProtectedComponent = ({
  callback = () => true,
  children = null,
  allowed = ["rank"],
  rank = "rank",
}) => {
  if (!allowed.includes(rank) || !callback()) {
    return null; // or render a fallback component to inform the user
  }
  return <>{children}</>; // render the children if permission is allowed
};
